import React, { Component } from "react";
import { Link } from "react-router-dom";
import { reduxForm } from "redux-form";
import Grid from "../../Utils/Grid";
import { standardActions } from "../../Utils/Grid/StandardActions"; // fallback if needed
import { canCreate, canEdit, canDelete, MODULES } from "../../../../utility/permissions";
import "./emergency-types.css";
import Swal from 'sweetalert2';

class List extends Component {
    componentDidMount() {
        this.props.listar();
    }

    handleSearch = (e) => {
        if (this.props.searchChange) {
            this.props.searchChange(e.target.value);
        }
    };

    render() {
        const { listar, data, loader, onSortChange, searchChange, eliminar, me } = this.props;

        return (
            <div className="emergency-types-page-container">
                {/* Header */}
                <div className="emergency-types-page-header">
                    <div className="header-left">
                        <div className="title-section">
                            <h1>Tipos de Emergencias</h1>
                            <p className="subtitle">Listado general de tipos de emergencia</p>
                        </div>
                    </div>
                    <div className="header-actions">
                        {/* Only show create button if admin or has permission */}
                        {canCreate(me, MODULES.EMERGENCY_TYPES) && (
                            <Link to="/emergency-types/create" className="btn-emergency-types-primary">
                                <span className="material-icons">add_circle_outline</span>
                                Crear Tipo de Emergencia
                            </Link>
                        )}
                    </div>
                </div>

                {/* Content Card */}
                <div className="emergency-types-card">
                    {/* Search Bar - Right Aligned */}
                    <div className="emergency-types-search-section">
                        <div className="emergency-types-search-wrapper">
                            <input
                                type="text"
                                placeholder="Buscar"
                                onChange={this.handleSearch}
                            />
                            <span className="material-icons search-icon">search</span>
                        </div>
                    </div>

                    {/* Table */}
                    <Grid
                        data={data}
                        loading={loader}
                        onPageChange={listar}
                        onSortChange={onSortChange}
                        columns={[
                            { dataField: "code", sort: true, text: "Código" },
                            { dataField: "name", sort: true, text: "Nombre" },
                            { dataField: "description", sort: true, text: "Descripción" },
                            {
                                dataField: "id",
                                text: "Acciones",
                                style: { width: '150px', textAlign: 'center' },
                                headerStyle: { textAlign: 'center' },
                                formatter: (cell, row) => (
                                    <div className="d-flex justify-content-center gap-2">
                                        <Link to={`/emergency-type/${cell}`} className="btn-action-view" title="Ver">
                                            <span className="material-icons">visibility</span>
                                        </Link>
                                        {canEdit(me, MODULES.EMERGENCY_TYPES) && (
                                            <Link to={`/emergency-type/${cell}/editar`} className="btn-action-edit" title="Editar">
                                                <span className="material-icons">edit</span>
                                            </Link>
                                        )}
                                        {canDelete(me, MODULES.EMERGENCY_TYPES) && (
                                            <button
                                                className="btn-action-delete"
                                                title="Eliminar"
                                                onClick={() => eliminar(cell)}
                                            >
                                                <span className="material-icons">delete</span>
                                            </button>
                                        )}
                                    </div>
                                )
                            }
                        ]}
                    />
                </div>
            </div>
        );
    }
}

export default reduxForm({
    form: "EmergencyTypes",
})(List);
